import { Box, Stepper, Step, StepIndicator, StepStatus, StepSeparator, useSteps, StepIcon, Progress, Text, Flex, Breadcrumb, BreadcrumbItem, BreadcrumbLink, } from "@chakra-ui/react";
import { BasicDetails, EmploymentExperience, DocumentUpload, IdentityBank, SalaryCompensation, } from "./components";
import * as routesNames from "../../../constants/routes";
import MyDiv from "./addNewEmployee.style";
import { CustomToast } from "../../../components";
import { useNavigate } from "react-router-dom";
import { useState, ComponentType } from "react";
import { BasicDetailsForm, EmploymentExperienceForm, IdentityBankForm, SalaryCompensationForm } from "./modal";
import FamilyDetail from "./components/FamilyDetail";
import EducationDetails from "./components/EducationDetails";

const steps = [
  { title: "Basic Details", component: BasicDetails },
  { title: "Employment & Experience", component: EmploymentExperience },
  { title: "Family Detail", component: FamilyDetail },
  { title: "Education Details", component: EducationDetails },
  { title: "Salary & Compensation", component: SalaryCompensation },
  { title: "Identity & Bank", component: IdentityBank },
  { title: "Documents Upload", component: DocumentUpload },
];

const AddNewEmployee = () => {
  const { addToast } = CustomToast();
  const navigate = useNavigate();
  const { activeStep, setActiveStep } = useSteps({
    index: 0,
    count: steps.length,
  });

  const [basicDetails, setBasicDetails] = useState<BasicDetailsForm>({
    employeeId: null,
    fullName: "",
    personalEmail: "",
    phoneNumber: "",
    whatsAppNumber: "",
    gender: 0,
    dob: "",
    current_Address: "",
    current_Zipcode: "",
    current_Country: "",
    current_State: "",
    current_City: "",
    joiningDate: "",
    officialEmail: "",
    usPhone: "",
    usCompanyId: 0,
    branch: 0,
    department: 0,
    designation: 0,
    shift: 0,
    permanent_Address: "",
    permanent_Zipcode: "",
    permanent_Country: "",
    permanent_State: "",
    permanent_City: "",
    role: [],
    employee_Code: "",
    emergency_Contact_Name: "",
    emergency_Contact_Number: "",
    blood_Group_Id: 0,
  });

  const [employment, setEmployment] = useState<EmploymentExperienceForm>({
    employeeId: 0,
    payrollCompanyId: 0,
    businessProcessId: 0,
    experience: 0,
    lastOrganisation: "",
    referenceId: 0,
    managerId: 0,
    teamLeadId: 0,
  });

  const [familyDetail, setFamilyDetail] = useState<any>({})
  const [educationDetail, setEducationDetail] = useState<any>({})
  const [salary, setSalary] = useState<SalaryCompensationForm>({
    employeeId: 0,
    grossSalaryYear: 0,
    grossSalaryMonth: 0,
    basicSalary: 0,
    hra: 0,
    specialAllowance: 0,
    conveyance: 0,
    epf: 0,
    netSalary: 0,
  });
  const [identity, setIdentity] = useState<IdentityBankForm>({
    employeeId: 0,
    aadhaar: "",
    pan: "",
    uan: "",
    hasEsic: false,
    account_Number: "",
    bank_Name: 0,
    branch_Name: "",
    ifsc_Code: "",
    // esic: "",
  });
  const [employeeDocuments, setEmployeeDocuments] = useState<any>({});
  const [employeeId, setEmployeeId] = useState<number | null>(null); // link across APIs

  const nextStep = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep(activeStep + 1);
    } else {
      addToast({ message: "Employee added successfully", status: "success" });
      navigate(routesNames.EMPLOYEES);
    }
  };

  const prevStep = () => setActiveStep(Math.max(0, activeStep - 1));

  const progressPercent = (activeStep / (steps.length - 1)) * 100;
  const CurrentComponent: ComponentType<any> = steps[activeStep].component;

  return (
    <MyDiv>
      {/* Breadcrumb */}
      <Box ml={3}>
        <Flex className="page_heading">
          <Breadcrumb spacing="5px" className="font_poppins text_md text_medium" separator=">>" >
            <BreadcrumbItem>
              <BreadcrumbLink className="font_poppins text_md text_medium" href={routesNames.EMPLOYEES} color="gray.500" >
                Employees
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem isCurrentPage>
              <BreadcrumbLink className="font_poppins text_md text_medium">
                Add New Employee
              </BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>
        </Flex>
      </Box>

      {/* Stepper */}
      <Box p={4}>
        <Box position="relative" mb={12}>
          <Stepper size="sm" index={activeStep} gap="0" colorScheme="green">
            {steps.map((_, index) => (
              <Step key={index} gap="0">
                <StepIndicator bg="white">
                  <StepStatus complete={<StepIcon />} />
                </StepIndicator>
                <StepSeparator />
              </Step>
            ))}
          </Stepper>

          <Progress value={progressPercent} position="absolute" height="3px" width="full" top="10px" zIndex={-1} />

          {/* Step Labels */}
          <Flex width="full" position="relative" mt={2}>
            {steps.map((step, index) => (
              <Box
                key={index}
                position="absolute"
                left={`${(index / (steps.length - 1)) * 100}%`}
                transform={
                  index === 0
                    ? "translateX(0)"
                    : index === steps.length - 1
                      ? "translateX(-100%)"
                      : "translateX(-50%)"
                }
                textAlign="center"
                width="max-content"
              >
                <Text className="font-poppins" fontSize="xs" fontWeight={activeStep === index ? "bold" : "normal"} color={activeStep === index ? "green.500" : "black"}>
                  {step.title}
                </Text>
              </Box>
            ))}
          </Flex>
        </Box>

        <CurrentComponent
          nextStep={nextStep}
          prevStep={prevStep}
          employeeId={employeeId}
          setEmployeeId={setEmployeeId}
          basicDetails={basicDetails}
          setBasicDetails={setBasicDetails}
          usCompanyId={basicDetails.usCompanyId}
          branchId={basicDetails.branch}
          departmentId={basicDetails.department}
          employment={employment}
          setFamilyDetail={setFamilyDetail}
          familyDetail={familyDetail}
          setEducationDetail={setEducationDetail}
          educationDetail={educationDetail}
          setEmployment={setEmployment}
          salary={salary}
          setSalary={setSalary}
          identity={identity}
          setIdentity={setIdentity}
          employeeDocuments={employeeDocuments}
          setEmployeeDocuments={setEmployeeDocuments}
        />
      </Box>
    </MyDiv>
  );
};

export default AddNewEmployee;
